<template>
  <Layout>
    <PageHeader
      :title="title"
      :subTitle="subTitle"
      :items="breadcrumbItems"
      hasBreadcrumb
      hasBackButton
    />

    <b-card>
      <McEditableTable
        v-show="isTableDataAvailable"
        ref="table"
        searchable
        hasEmit:submitError
        :fields="fields"
        :apiClient="apiClient"
        :apiErrorMappings="apiErrors"
        @available-change="handleDataAvailable"
        @submitError="handleSubmitError"
      />
      <div v-show="!isTableDataAvailable" class="empty-table-container">
        <img src="@/assets/images/no-data-illustration.png" alt />
        <strong>{{ $t('setting.list.costCategory.empty') }}</strong>
        <p>{{ $t('setting.list.costCategory.add') }}</p>
        <b-button variant="primary" @click="handleAdd">
          <i class="mc-fa icon-outline_plus"></i> {{ $t('global.addField') }}
        </b-button>
      </div>
    </b-card>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import McEditableTable from '@/components/McEditableTable'
import * as CostCategory from '@/services/rest-api/lib/cost-management/category'
import apiErrors from './lib/constants/api-errors'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Master Kategori Biaya',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McEditableTable,
  },
  data() {
    return {
      isTableDataAvailable: true,
      apiErrors: apiErrors,
    }
  },
  computed: {
    title() {
      return this.$t('setting.homePage.costCategory')
    },
    subTitle() {
      return this.$t('setting.homePage.listCostCategory')
    },
    apiClient() {
      return {
        get: CostCategory.get,
        show: CostCategory.show,
        update: CostCategory.update,
        store: CostCategory.store,
        delete: CostCategory.deleteSingle,
      }
    },
    fields() {
      const fields = [
        {
          name: 'name',
          label: this.$t('setting.list.costCategory.name'),
          placeholder: this.$t('setting.list.costCategory.placeholder'),
          key: 'name',
          isSortable: true,
          editable: true,
          validation: 'required|max:255,length',
        },
        {
          name: 'chart_of_account',
          label: this.$t('setting.list.costCategory.accountNumberName'),
          placeholder: this.$t('setting.list.costCategory.accountNumberPlaceholder'),
          key: 'chart_of_account',
          isSortable: true,
          editable: true,
          validation: 'max:255,length',
        },
      ]

      return fields
    },
    breadcrumbItems() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: '/setting',
        },
        {
          text: this.$t('setting.homePage.costCategory'),
        },
      ]
    },
  },
  methods: {
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    handleAdd() {
      this.$refs.table.handleAdd()
    },
    handleSubmitError(data) {
      if (data.errors && data.status == 400) {
        if (data.errors.name && data.errors.name[0] == 'value is not unique') {
          this.$mcToast.error(this.$t('setting.list.costCategory.fail'))
          return
        }

        this.$mcToast.error(this.$t('setting.wrongFormat'))
      }
    },
  },
}
</script>
